import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "./RichTextArea.css";

export default function RichTextarea({
  name,
  label,
  id,
  error,
  type,
  value,
  onChange,
  ...props
}) {
  return (
    <div style={{ width: "100%" }}>
      <div className="richtextarea__label">{name}</div>
      <div className="container__main__content__details__main__input">
        <CKEditor
          editor={ClassicEditor}
          config={{
            toolbar:
              [
                "heading",
                "|",
                "700",
                "italic",
                "bold",
                "link",
                "bulletedList",
                "numberedList",
                'alignment', '|',
                'blockQuote', 'codeBlock', 'htmlEmbed', '|',
                'alignment', '|',
                'specialCharacters', 'horizontalLine', 'pageBreak', '|',
              ],


            placeholder: "Enter Description",

          }}

          data={value}
          // onChange={onChange}
          onChange={(_event, editor) => {
            const data = editor.getData();
            onChange(editor.getData());
          }}
          {...props}
        />
      </div>
    </div>
  );
}
